import React from 'react';
import { ConfirmModal } from './ui.jsx';

export default function DurationChangeModal({ pendingDuration, onCancel, onConfirm }) {
  return (
    <ConfirmModal
      open={pendingDuration != null}
      testId="duration-change-modal"
      title="Change appointment duration?"
      cancelLabel="Cancel"
      confirmLabel="Yes, continue"
      confirmClass="bg-civix-purple hover:bg-civix-purple/80"
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      Changing the appointment duration will reset your customized availability grid and reminder
      timeframes to match the new duration. Are you sure you want to continue?
    </ConfirmModal>
  );
}
